import type { RenderProps } from 'hb-builder/components/common/type/RenderProps';
import { HeadlineWrapper } from 'hb-builder/components/RenderComponents/page/single/Headline/components/HeadlineWrappers';
import type { RenderComponent } from 'hb-builder/types';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { HeadlineItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/headlineItemAttributes';

const componentType = 'single';

const Headline: RenderComponent = () => <div />; // never used

const Render = ({
  children,
  item,
}: RenderProps<DocumentItem<HeadlineItemAttributes>>) => {
  const { attributes } = item || {};

  return (
    <HeadlineWrapper
      attributes={attributes}
      children={children}
      componentType={componentType}
    />
  );
};

Headline.componentName = 'Headline';
Headline.Render = Render;

export default Headline;
